import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Autenticador from '../../servicios/Autenticador';
import Seguridad from '../../servicios/Seguridad';


class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validacion: null
    }
  }

  async componentDidMount() {
    const validacion = await Seguridad.ValideIngresoUsuario(Autenticador.ObtengaIdentificacionEnIdToken());

    if(validacion.EsValido){
      await Autenticador.IniciarSesion();
    }

    this.setState({validacion});
  }

  render() {
    if(this.state.validacion === null){
      return null;
    }

    if(!this.state.validacion.EsValido){
      return <Redirect to={{
        pathname: "/Error",
        state: { errores: this.state.validacion.Errores },
      }} />
    }

    return null;
  }
}

export default Dashboard;